import { CheckCircleFilled, ExclamationCircleFilled } from "@ant-design/icons"
import { Form, Select, Tooltip } from "antd"
import React, { useRef, useState } from "react"
import upload from "../../assets/images/upload.svg"
import useNotify from "../../utils/useNotify"
import { useRecoilValue, useSetRecoilState } from "recoil"
import PreviewDocsModalProbe from "./previewDocsModalProbe"
import { addOrgDocsMeta, getPresignedURLOrg } from "../../services/httpCalls"
import { orgmode, showloader } from "../../store/gloabalState"
import { checkFileExtension } from "../../utils/check-file-extension"

const FileUploadCustom = ({
  name,
  type,
  uploadedFileList,
  uploadedFileLinks,
  isUploaded,
  setRefreshDocs,
  refresh,
  selectBox,
  selectedAddressProof,
  setSelectedAddressProof
}) => {
  const [selectedFile, setSelectedFile] = useState(null)
  const [fileName, setFileName] = useState("")

  const [errorMessage, setErrorMessage] = useState("")
  const setShowLoader = useSetRecoilState(showloader)
  // const [showLoader, setShowLoader] = useState(false)
  const inputRef = useRef()
  const notify = useNotify()
  const mode = useRecoilValue(orgmode)

  const uploadFileToS3 = (url, file) => {
    return fetch(url, {
      method: "PUT",
      body: file,
      headers: { "Content-Type": file.type }
    })
  }

  const resetFile = () => {
    // setErrorMessage('')
    setFileName("")
    setSelectedFile(null)
    inputRef.current.value = null
  }
  const cdocsUpload = async (files, docType) => {
    let preSignedUrl
    if(name === "custom_address_proof" && selectedAddressProof === ""){
      notify.error("Please select address proof type")
      return
    }
    if (files.length) {
      setShowLoader(true)
      let orgId = localStorage.getItem("orgId")
      await getPresignedURLOrg(orgId, files[0].name)
        .then(async res => {
          preSignedUrl = res.preSignedUrl.split("?")[0]
          await uploadFileToS3(res.preSignedUrl, files[0])
            .then(async () => {
              let OrgData = {
                organisationFileMetaList: [
                  {
                    documentType: name === "custom_address_proof" ? selectedAddressProof : name,
                    url: preSignedUrl,
                  },
                ],
              };
              await addOrgDocsMeta(orgId, OrgData)
                .then(res => {
                  notify.success(`${name.replaceAll("_", " ")} UPLOADED`)
                  setErrorMessage("")
                  // resetFile()
                  setRefreshDocs(!refresh)
                })
                .catch(err => {
                  notify.error("Error while uploading!")
                  setErrorMessage("Error while uploading!")
                  resetFile()
                })
                .finally(() => {
                  setShowLoader(false)
                })
            })
            .catch(err => {
              notify.error("Error while uploading to S3")
              setErrorMessage("Error while uploading to S3")
              resetFile()
            })
            .finally(() => setShowLoader(false))
        })
        .catch(err => {
          notify.error("Error genrating Presigned URL")
          resetFile()
        })
        .finally(() => setShowLoader(false))
    }
  }
  const validFileSize = (size, name) => {
    if (size * 0.001 >= 1024 * 10) {
      notify.error("File size is more than 10MB!")
      setErrorMessage("Please upload file with size less than 10MB")
      resetFile()
      return false
    }
    return true
  }
  function hasSpecialCharacters(filename) {
    const regex = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,<>\/?~]/
    return regex.test(filename)
  }
  const handleFileSelect = e => {
    if (e.target.files?.length) {
      if(!checkFileExtension(e.target?.files[0]?.name)){
        notify.error("Please upload a file with proper extension!");
        resetFile();
      }
      if (!hasSpecialCharacters(e.target?.files[0]?.name)) {
        let sizeofFile = e.target.files[0]?.size
        if (validFileSize(sizeofFile, e.target.name)) {
          setSelectedFile(e?.target?.files?.[0])
          setFileName(e?.target.files[0]?.name)
          cdocsUpload(e.target.files, e.target.name)
        }
      } else {
        setErrorMessage(
          "Please remove special characters from file name such as [,(),#,!,@,~,&,$,%,*,/,|,?,<,} and re-upload eg. XYZ.pdf or xyz123 file.pdf"
        )
        resetFile()
      }
    } else {
      notify.error("No file Selected!")
      resetFile()
    }
  }
  
  return (
    <Form.Item
      disabled={mode === 'view' ? true : false}
      label={
        <>
          {
            <div style={{ display: "flex", alignItems: "center" }}>
              <span
                style={{
                  fontWeight: "500",
                  fontSize: ".9rem",
                  letterSpacing: ".5px"
                }}
              >
                {type === "custom_address_proof" ? "ADDRESS PROOF" : type}
              </span>
              {
                selectBox !== undefined && (
                  <Select
                    placeholder="Select"
                    style={{ width: 120, marginLeft:".5rem" }}
                    options={selectBox?.options}
                    value={selectedAddressProof}
                    onChange={(e) => setSelectedAddressProof(e)}
                  />
                )
              }
              {isUploaded ? (
                <>
                  <CheckCircleFilled
                    style={{
                      color: "green",
                      fontSize: "16px",
                      marginLeft: ".5rem"
                    }}
                  />
                  <PreviewDocsModalProbe url={uploadedFileLinks[name]} />
                </>
              ) : (
                <ExclamationCircleFilled
                  style={{
                    color: "red",
                    fontSize: "16px"
                  }}
                />
              )}
            </div>
          }
        </>
      }
      labelCol={20}
      name={name}
    >
      <div style={{ margin: "0.5rem 0" }}>
        <div
          className={`${errorMessage
            ? "border-error"
            : isUploaded
              ? "border-uploaded"
              : "border"
            }`}
        >
          <div className="file-upload">
            <img src={upload} alt="" />
            <Tooltip
              title={
                fileName
                  ? fileName
                  : uploadedFileList[name]
                    ? uploadedFileList[name]
                    : "No file Selected"
              }
            >
              <h4 className="filename_text">
                {" "}
                {fileName
                  ? fileName
                  : uploadedFileList[name]
                    ? uploadedFileList[name]
                    : "No file Selected"}
              </h4>
            </Tooltip>
            <input type="file"
              onChange={handleFileSelect}
              ref={inputRef}
              disabled={mode === 'view' ? true : false}
            />
            <div />
          </div>
        </div>
        <p className="error_message">{errorMessage ? errorMessage : ""}</p>
      </div>
    </Form.Item>
  )
}

export default FileUploadCustom
